import { retrieveMethod } from "./resource";
const resource = "postcodes";
export const retrieve = (client, postcode, request) => retrieveMethod({
    resource,
    client,
})(postcode, request);
